<template>
  <div>
    <v-dialog scrollable v-model="show_dialog" width="700">
      <v-card>
        <v-card-title class="primary_2 text-h6 white--text py-2">
          Eligibility Rejection Count
          <v-spacer></v-spacer>
          <v-btn fab small text @click="closeDialog()">
            <v-icon large color="white">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-row class="ma-0" v-if="rejection_list_loading">
            <v-col>
              <v-skeleton-loader
                type="list-item , list-item"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="ma-0" v-else>
            <v-col cols="12" class="pb-0">
              <v-text-field
                label="Search"
                placeholder="Search"
                v-model="search"
                outlined
                hide-details
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-menu
                v-model="date_filter_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="290px"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="display_daterange"
                    v-on="on"
                    class="filter"
                    dense
                    label="Filter by Date Range"
                    outlined
                    placeholder="Filter by Date Range"
                    readonly
                    single-line
                  >
                    <template slot="append">
                      <v-icon
                        v-if="date_range.length > 1"
                        @click="clearDateFilter()"
                        >mdi-close</v-icon
                      >
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="date_range" :max="today" range>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="
                      date_range = [];
                      date_filter_menu = false;
                    "
                    >Cancel</v-btn
                  >
                  <v-btn color="primary" text @click="formateDisplayDate()"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <div class="test-h6">
                Total Count:
                <b>
                  {{ total_reason_count.toLocaleString("en-IN") }}
                </b>
              </div>
            </v-col>

            <v-col cols="12">
              <v-chip
                v-for="(item, index) in filtered_list"
                :key="index"
                class="ma-2"
                color="error"
                outlined
              >
                <span class="chip-text">
                  {{ item.iec_rejection_reason }} --
                </span>
                <b>
                  {{ item.reason_count.toLocaleString("en-IN") }}
                </b>
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  getDefaultSignupDateRangeIso,
  formatSignupDateRangeDisplay,
} from "@/utils/defaultSignupDateRange";
export default {
  data() {
    return {
      show_dialog: false,
      search: "",
      rejection_list: [],
      product_type: "",
      rejection_list_loading: false,
      date_filter_menu: false,
      display_daterange: formatSignupDateRangeDisplay(getDefaultSignupDateRangeIso()),
      date_range: getDefaultSignupDateRangeIso(),
      today: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    filtered_list() {
      if (!this.search) {
        return this.rejection_list;
      }

      return this.rejection_list.filter((item) =>
        item.iec_rejection_reason
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
    total_reason_count() {
      return this.filtered_list.reduce((total, item) => {
        return total + (item.reason_count || 0);
      }, 0);
    },
  },
  methods: {
    async openEligibilityRejection(product_type) {
      this.product_type = product_type;
      this.show_dialog = true;
      await this.getEligibilityRejectionList();
    },
    closeDialog() {
      this.show_dialog = false;
      this.rejection_list = [];
    },
    formateDisplayDate() {
      console.log(this.date_range);
      this.display_daterange = this.formateDisplayDateRange(this.date_range);
      this.date_filter_menu = false;
      this.getEligibilityRejectionList();
    },
    formateDisplayDateRange(daterange) {
      // console.log(daterange);
      let date1 = daterange[0];
      let date2 = daterange[1];
      let to = "";
      let from = "";
      if (date1 > date2) {
        to = date1;
        from = date2;
      } else {
        to = date2;
        from = date1;
      }
      // console.log(from);
      if (!to) to = from;
      daterange[0] = from;
      daterange[1] = to;
      from = this.display_date_formate(from);
      to = this.display_date_formate(to);
      return `${from} to ${to}`;
    },
    clearDateFilter() {
      this.date_filter_menu = false;
      this.display_daterange = "";
      this.date_range = [];
      this.getEligibilityRejectionList();
    },
    formatData(data) {
      return data.map((item) => ({
        ...item,
        iec_rejection_reason: item.iec_rejection_reason
          .replaceAll("[", "")
          .replaceAll("]", "")
          .replaceAll("'", "")
          .replaceAll("_", " ")
          .trim(),
      }));
    },
    getEligibilityRejectionList() {
      const self = this;
      self.rejection_list_loading = true;
      const lookup_key = "";
      let params = {
        product_type: self.product_type,
      };
      if (this.date_range) {
        params.from_date = this.date_range[0];
        params.to_date = this.date_range[1];
      }
      const successHandler = (response) => {
        this.rejection_list = this.formatData(response.data.result);
        self.rejection_list_loading = false;
        // this.rejection_list = this.formatData(this.result);
      };
      const finallyHandler = () => {
        self.rejection_list_loading = false;
      };
      self.GET_request(
        self,
        self.$urls.INTERNAL_ELIGIBILITY_BREAKUP,
        lookup_key,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
  },
};
</script>
<style scoped>
.chip-text {
  color: #000 !important;
  padding-right: 5px;
}
</style>
